import './tripList.css';
import {useState} from "react";
import {NavLink} from "react-router-dom";

const TripList = ({page = ''}) => {
    const [selectedTrip, setSelectedTrip] = useState(2);
    const handleSelectTrip = (index) => {
        setSelectedTrip(index);
    }

    return (
        <ul className={'trip-list'}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((trip) =>
                <li key={trip} className={trip === selectedTrip ? 'selected' : ''}
                    onClick={e => handleSelectTrip(trip)}>
                    {page === 'live-track' &&
                        <NavLink to={`${trip}`} className="flex gap-10 font-15 sf-medium margin-b-5 highlight-color">
                            <div className={'from'}>Bangalore</div>
                            <div className="connector"></div>
                            <div className="to">Chennai</div>
                        </NavLink>
                    }

                    {!page &&
                        <div className="flex gap-10 font-15 sf-medium margin-b-5">
                            <div className={'from'}>Bangalore</div>
                            <div className="connector"></div>
                            <div className="to">Chennai</div>
                        </div>
                    }
                    <div className="trip-details">
                        <ul className="separator font-14 gap-20 margin-b-5">
                            <li>289 kms</li>
                            <li>4.3 Hrs</li>
                        </ul>
                        <div className="font-12 grey-color">Aug 28 9:36 - 13:05</div>
                    </div>
                </li>
            )}
        </ul>
    )
}

export default TripList;
